// getDailyPromoItem.ts

import type { z } from "zod";
import type { ExtendedFeedItemSchema } from "../../../schemas/slices/FeedSliceSchema";
import {
    dailyPromoSchedule,
    type DailyPromoLocalizedText,
    type DailyPromoWeekday,
} from "./dailyPromo.config";

const WEEKDAY_BY_DAY_INDEX: readonly DailyPromoWeekday[] = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
];

const EMPTY_LOCALIZED_TEXT: DailyPromoLocalizedText = {
    en: "",
    es: "",
    "pt-br": "",
    id: "",
    th: "",
};

export function getDailyPromoItem(
    date = new Date(),
): z.infer<typeof ExtendedFeedItemSchema> {
    const weekday = WEEKDAY_BY_DAY_INDEX[date.getDay()] ?? "monday";
    const promo = dailyPromoSchedule[weekday];
    const deeplinkUrl = `https://world.org/mini-app?app_id=${promo.appId}&path=${encodeURIComponent(
        promo.path,
    )}`;

    return {
        productType: "PARTNER_LINK",
        category: "PARTNER_CAMPAIGN",
        itemId: promo.itemId,
        uid: `partner_link:${promo.itemId}`,
        thumbnailUrl: promo.thumbnailUrl,
        title: promo.title,
        subtitle: promo.subtitle,
        raw: {
            id: promo.rawId,
            title: EMPTY_LOCALIZED_TEXT,
            subtitle: EMPTY_LOCALIZED_TEXT,
            thumbnailUrl: promo.thumbnailUrl,
            deeplinkUrl,
        },
        relation: null,
        listingToken: undefined,
        spotsLeft: null,
    };
}
